import React from "react";

function index() {
  return (
    <div className="text" style={{ maxHeight: "70vh", overflow: "auto" }}>
      <p style={{ textAlign: "justify", margin: "0px 0px 0px" }}>
        Data DEMNAS yang dirilis dipotong sesuai dengan Nomor Lembar Peta (NLP)
        skala 1:50k atau 1:25k, untuk setiap Pulau atau Kepulauan. Ringkasan
        data set karakteristik DEMNAS, seperti berikut:
        <br />
      </p>
      <div className="table-responsive" style={{ padding: "10px" }}>
        <table className="table table-striped table-sm">
          <thead>
            <tr>
              <th>Item</th>
              <th>Keterangan</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Nama file</td>
              <td>
                DEMNAS_xxxx-yy-v1.0.tif untuk NLP 1:50k
                dan&nbsp;DEMNAS_xxxx-yyy-v1.0.tif &nbsp;untuk 1:25k. xxxx-yy
                menunjukkan nomor lembar peta RBI dan v1.0 menunjukkan rilis
                versi 1.0
              </td>
            </tr>
            <tr>
              <td>Resolusi</td>
              <td>0.27-arcsecond</td>
            </tr>
            <tr>
              <td>Datum</td>
              <td>EGM2008</td>
            </tr>
            <tr>
              <td>Sistem Koordinat</td>
              <td>Geografis</td>
            </tr>
            <tr>
              <td>Format</td>
              <td>Geotiff 32bit float</td>
            </tr>
          </tbody>
        </table>
      </div>
      {/*
      <p style={{ textAlign: "justify", margin: "0px 0px 0px" }}>
        Sementara itu data BATNAS dibagi dalam blok dengan luas 5 derajat x 5
        derajat dengan pertimbangan besaran data dan memudahkan proses download.
        Spesifikasi data BATNAS, seperti berikut:
        <br />
      </p>
      <div className="table-responsive" style={{ padding: "10px" }}>
        <table className="table table-striped table-sm">
          <thead>
            <tr>
              <th>Item</th>
              <th>Keterangan</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Nama file</td>
              <td>
                BATNAS_xxxE-xxxE_yyy-yyy_EGM_v1.0.tif atau
                BATNAS_xxxE-xxxE_yyy-yyy_MSL_v1.0.tif, xxx batas timur dan
                barat, dan yyy menunjukkan batas selatan sampai utara serta
                &nbsp;v1.0 menunjukkan rilis versi 1.0. EGM dan MSL
                masing-masing menunjukkan datum tinggi yang digunakan sebagai
                acuan.
              </td>
            </tr>
            <tr>
              <td>Resolusi</td>
              <td>
                6-<em>arcsecond</em>
              </td>
            </tr>
            <tr>
              <td>Datum</td>
              <td>EGM2008 dan MSL</td>
            </tr>
            <tr>
              <td>Sistem Koordinat</td>
              <td>Geografis</td>
            </tr>
            <tr>
              <td>Format</td>
              <td>Geotiff 32bit float</td>
            </tr>
          </tbody>
        </table>
      </div>*/}

      <h3 className="text-justify" style={{ fontSize: "18px" }}>
        <strong>Menggabungkan Data DEMNAS</strong>
      </h3>
      <p style={{ textAlign: "justify" }}>
        Untuk menggabungkan data DEMNAS dalam potongan NLP menjadi sebuah data
        seamless dengan area yang lebih luas, dapat digunakan&nbsp;
        <a href="http://www.gdal.org/">
          <em>Geospatial Data Abstraction Library</em>
        </a>
        <em> </em>(GDAL). &nbsp;Berikut contoh penggabungan data dengan GDAL
        menggunakan{" "}
        <a href="https://en.wikipedia.org/wiki/Unix_shell">
          <em>terminal</em>
        </a>
        <em>. </em>Menggabungkan 10(sepuluh) NLP data DEMNAS hanya diperlukan
        waktu 5 detik, dengan instruksi seperti berikut:
        <br />
      </p>
      <p style={{ textAlign: "justify", fontSize: "12px" }}>
        [kebo@tides SAMPLE]$ ls
        <br />
        DEMNAS_1314-23.tif DEMNAS_1314-31.tif DEMNAS_1314-34.tif
        DEMNAS_1314-61.tif DEMNAS_1314-63.tif
        <br />
        DEMNAS_1314-24.tif DEMNAS_1314-33.tif DEMNAS_1314-52.tif
        DEMNAS_1314-62.tif DEMNAS_1314-64.tif
        <br />
        [kebo@tides SAMPLE]$ echo "gdal_merge.py -o DEMNAS_large_area.tif" &gt;
        list1
        <br />
        [kebo@tides SAMPLE]$ ls DEMNAS_*.tif | tr -d ' \n ' | sed -e
        's/.tif/.tif /g' &gt; list2
        <br />
        [kebo@tides SAMPLE]$ paste list1 list2 &gt; command.sh
        <br />
        [kebo@tides SAMPLE]$ sh command.sh <br />
        0...10...20...30...40...50...60...70...80...90...100 - done.
        <br />
      </p>
      <h3 className="text-justify" style={{ fontSize: "18px" }}>
        <strong>
          <em>Plotting</em> data DEMNAS
        </strong>
      </h3>
      <p style={{ textAlign: "justify" }}>
        <em>Plotting</em> data DEMNAS dapat dilakukan dengan&nbsp;
        <a href="http://gmt.soest.hawaii.edu/">
          <em>Generic Mapping Tool </em>(GMT)
        </a>{" "}
        dan GDAL untuk konversi data dari GeoTiff menjadi{" "}
        <a href="https://www.unidata.ucar.edu/software/netcdf/">NetCDF</a>.
        Sebagai contoh, penggunaan&nbsp;<em>bourne-shell script </em>sederhana (
        <a href="http://tides.big.go.id/DEMNAS/shell/plot_demnas.bash">
          plot_demnas.bash
        </a>
        ) dengan perintah sebagai berikut:
      </p>
      <p style={{ textAlign: "justify", fontSize: "13px" }}>
        <strong>bash-3.2$ bash plot_demnas.bash&nbsp;</strong>
        <br />
        <em>
          &nbsp;penggunaan: bash plot_demnas.bash file_input.tif file_output.eps
          max_elev(meters)
        </em>
        <br />
        <em>
          &nbsp;contoh: bash plot_demnas.bash DEMNAS_0718-54_v1.0.tif
          DEMNAS_0718-54_v1.0.eps 200
        </em>
        <br />
        <strong>
          bash-3.2$ bash plot_demnas.bash DEMNAS_0718-54_v1.0.tif
          DEMNAS_0718-54_v1.0.eps 15
        </strong>
        <br />
        <em>Input file size is 3333, 3333</em>
        <br />
        <em>0...10...20...30...40...50...60...70...80...90...100 - done.</em>
        <br />
        <em>grd2cpt: Processing input grid(s)</em>
        <br />
        <em>grd2cpt: Mean and S.D. of data are 4.1996872704 2.81747693968</em>
        <br />
        <em>grdgradient: Processing input grid</em>
        <br />
        <em>
          grdgradient:&nbsp; Min Mean Max sigma intensities:grdgradient:
          -0.511577595155 9.02550576079e-05 0.53745034241 0.0418320305703
        </em>
        <br />
        <em>grdhisteq: Processing input grid</em>
        <br />
      </p>
      <figure style={{ textAlign: "center" }}>
        <img
          className="figure-img"
          src={process.env.PUBLIC_URL + "/static/img/DEMNAS_0718-54_v1.0.png"}
          style={{ width: "500px" }}
        />
        <figcaption style={{ padding: "10px" }}>
          Hasil <em>plotting </em>dengan GMT
        </figcaption>
      </figure>
      <h3 className="text-justify" style={{ fontSize: "18px" }}>
        <strong>Konversi Datum</strong>
      </h3>
      <p style={{ textAlign: "justify" }}>
        Datum tinggi yang digunakan dalam DEMNAS adalah EGM2008. Jika ingin
        menggunakan datum tinggi yang lain misalnya bidang matematis Elipsoid,
        MSL atau yang lainnya, dapat digunakan{" "}
        <a href="https://code.mpimet.mpg.de/projects/cdo/">CDO</a>&nbsp;untuk
        <em>regriding </em>data datum tinggi sesuai dengan potongan NLP data
        DEMNAS, atau langsung menggunakan&nbsp;<em>command-line tools </em>yang
        ada di GDAL.
      </p>
      <p style={{ textAlign: "justify" }}>
        Berikut contoh pemanfaatan&nbsp;&nbsp;<em>command-line tools (</em>
        <a href="http://tides.big.go.id/DEMNAS/shell/conv2ellipsoid.bash">
          <em>conv2ellipsoid.bash</em>
        </a>
        <em>)&nbsp;</em>yang ada di GDAL untuk mengembalikan datum tinggi dari{" "}
        <a href="http://tides.big.go.id/DEMNAS/datum/egm2008n_indo_1m.nc">
          EGM2008 ke elipsoid
        </a>
        .
      </p>
      <p style={{ textAlign: "justify", fontSize: "13px" }}>
        <strong>bash-3.2$ bash conv2ellipsoid.bash</strong>&nbsp;
        <br />
        <em>
          &nbsp;penggunaan: bash conv2ellipsoid.bash file_input.tif
          file_output.tif
        </em>
        <br />
        <em>
          &nbsp;contoh: bash conv2ellipsoid.bash DEMNAS_0718-54_v1.0.tif
          DEMNAS_EL_0718-54_v1.0.tif
        </em>
        <br />
        <strong>
          bash-3.2$ bash conv2ellipsoid.bash DEMNAS_0718-54_v1.0.tif
          DEMNAS_EL_0718-54_v1.0.tif
        </strong>
        <br />
        <em>Input file size is 4201, 3001</em>
        <br />
        <em>0...10...20...30...40...50...60...70...80...90...100 - done.</em>
        <br />
        <em>
          0 .. 10 .. 20 .. 30 .. 40 .. 50 .. 60 .. 70 .. 80 .. 90 .. 100 - Done
        </em>
        <br />
      </p>
    </div>
  );
}

export default index;
